<template>
  <a
    href="#"
    class="d-block p-11  menuHover my-1 px-4 py-1 font-medium text-gray-800"
    @click="$emit('onClick', value)"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: "AppDropdownItem",
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
};
</script>
